'use strict';

import { initAllModules, setCss } from './functions.js';
import MapModule from './MapModule.js';
import CarCarouselModule from './CarCarouselModule.js';
import KeepScrollModule from './KeepScrollModule.js';
import MoneyInputModule from './MoneyInputModule.js';
import FormModule from './FormModule.js';
import DragScrollModule from './DragScrollModule.js';
import Step2Module from './Step2Module.js';
import SelectValueModule from './SelectValueModule.js';
import MultipleChoiceModule from './MultipleChoiceModule.js';
import JoinRowspanTableModule from './JoinRowspanTableModule.js';
import GeocoderInputModule from './GeocoderInputModule.js';
import FormatTableDurationModule from './FormatTableDurationModule.js';
import ChargingTimeTableModule from './ChargingTimeTableModule.js';
import './elements/CalculationElement.js';
import './elements/ConditionalRenderElement.js';
import './elements/AjaxNavigationElement.js';
import './elements/BrandSelectorElement.js';
import './elements/GtagEventElement.js';
import './modules/ScrollGradientModule.js';
import './modules/ResultsPageModule.js';

window.modules = window.modules || {}

Object.assign(window.modules, {
    MapModule,
    CarCarouselModule,
    KeepScrollModule,
    MoneyInputModule,
    FormModule,
    DragScrollModule,
    Step2Module,
    SelectValueModule,
    MultipleChoiceModule,
    JoinRowspanTableModule,
    GeocoderInputModule,
    FormatTableDurationModule,
    ChargingTimeTableModule,
});

window.addEventListener('DOMContentLoaded', function() {
    initAllModules();
});

window.modules.TabsModule = function(element) {

    let tabs = element.querySelectorAll('a');

    tabs.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            let kdHideSelector = link.getAttribute('kd-hide');
            let kdShowSelector= link.getAttribute('kd-show');

            if (kdHideSelector) {
                setCss(kdHideSelector, {
                    display: 'none'
                })
            }

            if (kdShowSelector) {
                setCss(kdShowSelector, {
                    display: 'flex'
                })
            }

            tabs.forEach(function(link) {
                link.classList.remove('active');
            });

            e.target.classList.add('active');
        });
    });

    let activeTab = element.querySelector('a.active');

    if (!activeTab && tabs.length > 0) {
        tabs[0].classList.add('active');
    }

}
